import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Avatar, Typography } from '@material-ui/core';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { grey } from '@material-ui/core/colors';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import logo from '../images/lasa_logo.png'
import Loader from 'react-loader-spinner'
import { doLogin } from '../state/auth/authActions';

const styles = theme => ({
  root: {
    display: 'flex',
    backgroundColor: grey[200],
    height: '100vh'
  },
  avatarSmall: {
    color: '#FFF',
    backgroundColor: grey[300],
    width: 70,
    height: 70
  },
  iconSmall: {
    color: grey[500],
    width: 45,
    height: 45
  },
  icon: {
    color: grey[600],
    width: 100,
    height: 100,
    marginLeft: -16,
    marginRight: -16
  },
  logo: {
    color: '#FFF',
    backgroundColor: '#F80032',
    width: 70,
    height: 70,
    padding: 18
  },
  separate: {
    width: 20,
    height: 0,
    margin: 5,
    borderBottom: `2px dashed ${grey[500]}`
  },

  text: {
    minWidth: 220,
    textAlign: 'center',
    marginTop: 20,
  }

});

class Login extends React.Component {

  async componentDidMount() {

    const { doLogin } = this.props;
    if (!this.props.auth.token) await doLogin();
  }

  render() {

    // if (this.props.auth.isLoggingIn) {
    // this.props.history.push(`${consts.CONTEXT}/all-orders`);

    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <CssBaseline />
        <Grid container direction="column" justify="center" alignItems="center">
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid>
              <Avatar className={classes.logo} src={logo}></Avatar>
            </Grid>
          </Grid>
          <Grid className={classes.text}>
            <Loader
              type="ThreeDots"
              color="#7F8C8D"
              height={80}
              width={80}
            />
            <Typography variant="h6">Login</Typography>
          </Grid>
        </Grid>
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return { auth: state.auth };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ doLogin }, dispatch);
export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Login);
